<template>
  <div
    v-if="visible && municipio"
    class="modal-overlay"
    @click.self="$emit('close')"
  >
    <div class="modal-panel">
      <div class="modal-header">
        <h3>
          <span
            :class="['position-badge', getPositionClass(municipio.posicaoReal)]"
          >
            <i
              v-if="
                municipio.posicaoReal === 1 ||
                municipio.posicaoReal === 2 ||
                municipio.posicaoReal === 3
              "
              class="icofont-trophy"
            ></i>
            {{ municipio.posicaoReal }}º
          </span>
          <span>|</span>
          {{ estado == '' ? 'BR' : estado }}
          <span>|</span>
          {{ municipio.quadrimestre }}
          <!-- <span>|</span>
          {{ municipio.ibge }} -->
          <span>|</span>
          {{ municipio.municipio }} - {{ municipio.uf }}
        </h3>

        <button @click="$emit('close')">
          <i class="icofont-close"></i>
        </button>
      </div>

      <div class="modal-tabs">
        <button
          :class="{ active: activeTab === 'componentes' }"
          @click="activeTab = 'componentes'"
        >
          <i class="icofont-users"></i>
          Componentes
        </button>

        <button
          :class="{ active: activeTab === 'indicadores' }"
          @click="activeTab = 'indicadores'"
        >
          <i class="icofont-chart-line-alt"></i>
          Indicadores
        </button>
      </div>

      <div class="modal-content">
        <div v-show="activeTab === 'componentes'" class="modal-body">
          <div class="table-card">
            <table>
              <thead>
                <tr>
                  <th>Classificação</th>
                  <th>CVAT eSF</th>
                  <th>CVAT eAP</th>
                  <th>Qualidade eSF</th>
                  <th>Qualidade eAP</th>
                  <th>Qualidade eSB</th>
                  <th>Qualidade eMulti</th>
                  <th>Total</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="item in classificacoesComDados"
                  :key="item.key"
                  :class="getRowClass(item.key)"
                >
                  <td>{{ item.label }}</td>
                  <td>{{ formatEquipe(getStats(item.key).esf_cvat) }}</td>
                  <td>{{ formatEquipe(getStats(item.key).eap_cvat) }}</td>
                  <td>{{ formatEquipe(getStats(item.key).esf_qual) }}</td>
                  <td>{{ formatEquipe(getStats(item.key).eap_qual) }}</td>
                  <td>{{ formatEquipe(getStats(item.key).esb_qual) }}</td>
                  <td>{{ formatEquipe(getStats(item.key).emulti_qual) }}</td>
                  <td class="total-cell">
                    <strong>{{
                      formatEquipe(getStats(item.key).qtd_equipes)
                    }}</strong>
                    <small
                      v-if="Number(getStats(item.key).qtd_equipes || 0) > 0"
                    >
                      ({{ formatPercent(getStats(item.key).prcntl_eq_aval) }})
                    </small>
                  </td>
                </tr>
              </tbody>

              <tfoot>
                <tr>
                  <td>Total</td>
                  <td>{{ formatEquipe(totais.esf_cvat) }}</td>
                  <td>{{ formatEquipe(totais.eap_cvat) }}</td>
                  <td>{{ formatEquipe(totais.esf_qual) }}</td>
                  <td>{{ formatEquipe(totais.eap_qual) }}</td>
                  <td>{{ formatEquipe(totais.esb_qual) }}</td>
                  <td>{{ formatEquipe(totais.emulti_qual) }}</td>
                  <td class="total-cell">
                    <strong>{{ totais.qtd_equipes }} equipes</strong>
                    <small>(100%)</small>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div v-show="activeTab === 'indicadores'" class="modal-body">
          <div v-if="!indicadores.length" class="empty-indicadores">
            <i class="fas fa-file-upload"></i>
            <strong>Dados de Indicadores não encontrados</strong>
            <span> Nenhum indicador encontrado para este município. </span>
          </div>

          <div v-else class="table-card">
            <table>
              <thead>
                <tr>
                  <th>Indicador Avaliado</th>
                  <th>Regular</th>
                  <th>Suficiente</th>
                  <th>Bom</th>
                  <th>Ótimo</th>
                  <th>Desempenho</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, index) in indicadores" :key="index">
                  <td class="indicador-name">
                    <span class="tipo-equipe">{{ item.tp_eq }}</span>
                    <span>{{ item.ds_ind }}</span>
                  </td>
                  <td class="regular-cell">{{ formatEquipe(item.reg) }}</td>
                  <td class="suficiente-cell">{{ formatEquipe(item.suf) }}</td>
                  <td class="bom-cell">{{ formatEquipe(item.bom) }}</td>
                  <td class="otimo-cell">{{ formatEquipe(item.oti) }}</td>
                  <td class="desempenho-indicador">
                    {{ formatPercent(item.avg) }}
                  </td>
                </tr>
              </tbody>

              <tfoot>
                <tr>
                  <td colspan="5">Média</td>
                  <td class="desempenho-indicador media-cell">
                    {{ formatPercent(municipio.desempenhoIndicadores) }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RankingDetailsModal',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    municipio: {
      type: Object,
      default: null,
    },

    estado: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeTab: 'componentes',
      classificacoes: [
        { key: 'regular', label: 'Regular' },
        { key: 'suficiente', label: 'Suficiente' },
        { key: 'bom', label: 'Bom' },
        { key: 'otimo', label: 'Ótimo' },
      ],
    }
  },
  computed: {
    /**
     * Calcula os totais das colunas.
     *
     * @returns {Object}
     */
    totais() {
      const total = {
        esf_cvat: 0,
        eap_cvat: 0,
        esf_qual: 0,
        eap_qual: 0,
        esb_qual: 0,
        emulti_qual: 0,
        qtd_equipes: 0,
      }

      this.classificacoesComDados.forEach((classificacao) => {
        const stats = this.getStats(classificacao.key)

        total.esf_cvat += Number(stats.esf_cvat || 0)
        total.eap_cvat += Number(stats.eap_cvat || 0)
        total.esf_qual += Number(stats.esf_qual || 0)
        total.eap_qual += Number(stats.eap_qual || 0)
        total.esb_qual += Number(stats.esb_qual || 0)
        total.emulti_qual += Number(stats.emulti_qual || 0)
        total.qtd_equipes += Number(stats.qtd_equipes || 0)
      })

      return total
    },

    /**
     * Retorna os indicadores de cada município.
     */
    indicadores() {
      return Array.isArray(this.municipio?.indicadores)
        ? this.municipio.indicadores
        : []
    },

    /**
     * Retorna apenas classificações que possuem equipes.
     *
     * @returns {Array}
     */
    classificacoesComDados() {
      return this.classificacoes.filter((item) => {
        const stats = this.getStats(item.key)

        return Number(stats.qtd_equipes || 0) > 0
      })
    },
  },

  methods: {
    /**
     * Retorna os dados de uma classificação.
     *
     * @param {string} classificacao Nome da classificação.
     * @returns {Object}
     */
    getStats(classificacao) {
      return (
        this.municipio?.[classificacao] || {
          esf_cvat: 0,
          eap_cvat: 0,
          esf_qual: 0,
          eap_qual: 0,
          esb_qual: 0,
          emulti_qual: 0,
          qtd_equipes: 0,
          prcntl_eq_aval: 0,
        }
      )
    },

    /**
     * Retorna vazio quando o valor for zero.
     *
     * @param {number|string|null} value Valor numérico.
     * @returns {string}
     */
    formatZero(value) {
      return Number(value || 0) === 0 ? '' : String(value)
    },

    /**
     * Formata quantidade de equipes.
     *
     * @param {number|string|null} value Valor numérico.
     * @returns {string}
     */
    formatEquipe(value) {
      const number = Number(value || 0)

      if (number === 0) {
        return ''
      }

      return `${number} equipes`
    },

    /**
     * Formata valor percentual.
     *
     * @param {number|string|null} value Valor percentual.
     * @returns {string}
     */
    formatPercent(value) {
      return `${Number(value || 0).toFixed(1)}%`
    },

    /**
     * Retorna a classe da linha pela classificação.
     *
     * @param {string} classificacao Nome da classificação.
     * @returns {string}
     */
    getRowClass(classificacao) {
      return `row-${classificacao}`
    },

    /**
     * Retorna a classe visual da posição.
     *
     * @param {number} position Posição do município.
     * @returns {string}
     */
    getPositionClass(position) {
      if (position === 1) return 'first'
      if (position === 2) return 'second'
      if (position === 3) return 'third'

      return ''
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.55);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.modal-panel {
  background: #ffffff;
  border-radius: 16px;
  width: 100%;
  max-width: 1024px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.28);
  display: flex;
  flex-direction: column;
}

.modal-header {
  background: #f9fafb;
  border-bottom: 1px solid #f3f4f6;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 18px;
  color: #1f2937;
  font-weight: 800;
}

.modal-header h3 i {
  color: #4f46e5;
}

.modal-header h3 span {
  color: #d1d5db;
  font-weight: 700;
}

.modal-header button {
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  font-size: 18px;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  transition: 0.2s;
}

.modal-header button:hover {
  color: #ef4444;
  background: #fef2f2;
}

.modal-tabs {
  display: flex;
  gap: 8px;
  padding: 8px 20px 0;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.modal-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  padding: 12px;
  color: #6b7280;
  font-weight: 700;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  border-radius: 8px 8px 0 0;
  transition: 0.2s;
}

.modal-tabs button:hover {
  color: #4b5563;
  border-bottom-color: #d1d5db;
}

.modal-tabs button.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
}

.modal-content {
  overflow-y: auto;
}

.modal-body {
  padding: 20px;
  overflow-x: auto;
}

.table-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  color: #374151;
}

thead {
  background: #f3f4f6;
  font-weight: 700;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

th,
td {
  padding: 12px;
  border-bottom: 1px solid #f3f4f6;
  text-align: center;
}

th:first-child,
td:first-child {
  text-align: left;
}

tbody tr {
  transition: 0.2s;
}

tbody tr:hover {
  filter: brightness(0.98);
}

tfoot {
  background: #f3f4f6;
  color: #1f2937;
  font-weight: 900;
  border-top: 2px solid #d1d5db;
}

tfoot td {
  padding: 12px;
}

small {
  color: #6b7280;
  margin-left: 4px;
  font-size: 10px;
}

.row-regular {
  background: rgba(255, 247, 237, 0.6);
  color: #9a3412;
}

.row-suficiente {
  background: rgba(254, 252, 232, 0.7);
  color: #854d0e;
}

.row-bom {
  background: rgba(240, 253, 244, 0.7);
  color: #166534;
}

.row-otimo {
  background: rgba(239, 246, 255, 0.7);
  color: #1e40af;
}

.total-cell {
  font-weight: 900;
  color: #111827;
  border-left: 2px solid rgba(209, 213, 219, 0.8);
}

.indicador-name {
  color: #374151;
  font-weight: 700;
  min-width: 420px;
}

.tipo-equipe {
  display: inline-block;
  background: #e0e7ff;
  color: #4338ca;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  padding: 4px 7px;
  font-size: 10px;
  font-weight: 900;
  margin-right: 8px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.regular-cell {
  background: rgba(255, 247, 237, 0.45);
  color: #c2410c;
}

.suficiente-cell {
  background: rgba(254, 252, 232, 0.55);
  color: #a16207;
}

.bom-cell {
  background: rgba(240, 253, 244, 0.55);
  color: #15803d;
}

.otimo-cell {
  background: rgba(239, 246, 255, 0.55);
  color: #1d4ed8;
}

.desempenho-indicador {
  background: rgba(238, 242, 255, 0.7);
  color: #4338ca;
  font-weight: 900;
  border-left: 1px solid #e0e7ff;
}

.media-cell {
  font-size: 14px;
  background: rgba(224, 231, 255, 0.8);
}

.empty-indicadores {
  text-align: center;
  color: #6b7280;
  padding: 48px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.empty-indicadores i {
  font-size: 44px;
  color: #d1d5db;
}

.empty-indicadores strong {
  color: #374151;
  font-size: 18px;
}

.empty-indicadores span {
  font-size: 13px;
}

.position-badge {
  color: #000 !important;
  font-weight: 900;
}

.position-badge.first {
  background: #facc15;
  color: #ffffff !important;
  padding: 4px 8px;
  border-radius: 999px;
}

.position-badge i {
  color: #fff !important;
}

.position-badge.second {
  background: #c2cad6;
  color: #fff !important;
  padding: 4px 8px;
  border-radius: 999px;
}

.position-badge.third {
  background: #b45309;
  color: #ffffff !important;
  padding: 4px 8px;
  border-radius: 999px;
}

@media (max-width: 768px) {
  .modal-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .modal-panel {
    width: 100%;
    max-width: 100%;
    border-radius: 18px 18px 0 0;
  }

  .modal-header {
    padding: 14px 16px;
    align-items: flex-start;
    gap: 12px;
  }

  .modal-header h3 {
    flex-wrap: wrap;
    gap: 6px;
    font-size: 14px;
    line-height: 1.4;
  }

  .modal-header button {
    flex: 0 0 36px;
  }

  .modal-tabs {
    padding: 8px 12px 0;
    overflow-x: auto;
  }

  .modal-tabs button {
    white-space: nowrap;
    padding: 10px 12px;
    font-size: 12px;
  }

  .modal-content {
    flex: 1;
    overflow-y: auto;
  }

  .modal-body {
    padding: 12px;
    overflow-x: auto;
  }

  .table-card {
    overflow-x: auto;
    border-radius: 10px;
  }

  table {
    min-width: 760px;
    font-size: 11px;
  }

  th,
  td {
    padding: 10px 8px;
    white-space: nowrap;
  }

  .indicador-name {
    min-width: 320px;
    white-space: normal;
  }

  .tipo-equipe {
    margin-bottom: 4px;
  }
}
</style>
